import './EditAvatar.scss';
import { AvatarUploadModal } from './AvatarUploadModal';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CurrentUserAvatar } from '@ui/header';
import React, { useState } from 'react';
export const EditAvatar = () => {
    const [isEditOpen, setIsEditOpen] = useState(false);
    const toggleModal = () => setIsEditOpen((value) => !value);
    return (React.createElement("div", { className: 'edit-avatar' },
        React.createElement(CurrentUserAvatar, { large: true }),
        React.createElement(Button, { onClick: toggleModal, type: 'link' }, COPY_SPECIFIC.EDIT),
        React.createElement(AvatarUploadModal, { onAfterSave: toggleModal, onCancel: toggleModal, open: isEditOpen })));
};
